import { render, staticRenderFns } from "./SpecifyTemplateType.vue?vue&type=template&id=51549c80&"
import script from "./SpecifyTemplateType.vue?vue&type=script&lang=js&"
export * from "./SpecifyTemplateType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports